import { makeStyles } from '@/styles/theme/tss-react';

interface Props {
  darken?: boolean | undefined;
  desktopOnlyOverlay?: boolean | undefined;
  isThumbnailVisible: boolean;
}

const useStyles = makeStyles<Props>({ name: 'MediaOverlay' })(
  ({ breakpoints }, props) => ({
    relative: {
      position: 'relative',
    },
    videoPlayer: {
      position: props.desktopOnlyOverlay ? 'static' : 'absolute',
      width: '100% !important',
      height: '100% !important',
      inset: 0,

      [breakpoints.up('md')]: {
        position: 'absolute',
      },
    },
    image: {
      position: 'absolute',
      width: '100% !important',
      height: '100% !important',
      inset: 0,

      '& > img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },

      [breakpoints.up('md')]: {
        position: 'absolute',
      },
    },
    overlayContent: {
      position: props.desktopOnlyOverlay ? 'static' : 'absolute',
      inset: 0,
      backgroundColor: props.darken ? 'rgba(0, 0, 0, 0.6)' : undefined,

      [breakpoints.up('md')]: {
        position: 'absolute',
      },
    },

    // z-index classes
    videoPlayerZ: { zIndex: 0 },
    imageZ: { zIndex: props.isThumbnailVisible ? 1 : -1 },
    overlayContentZ: { zIndex: 2 },
  })
);

export default useStyles;
